import React, { useEffect, useState } from "react";
import { PopupModal, useCalendlyEventListener } from "react-calendly";

import { database } from "../config";
import { getAllData } from "../utilities/firebase-connection";

const Calendly = ({
	isDay,
	showChat,
	isOpen,
	setIsOpen,
	showPayment,
	setShowChat,
	setShowPayment,
}) => {
	const [userData, setUserData] = useState({});
	const [reload, setReload] = useState(false);

	async function getSystemId() {
		const response = await fetch("https://api.ipify.org?format=json");
		const data = await response.json();
		return data.ip;
	}

	useEffect(() => {
		let loadId;
		(async () => {
			const systemID = await getSystemId();
			const dt = await getAllData("sessionbooking");

			const userDt = dt.filter((_dt) => _dt?.usersystemip === systemID);
			setUserData(userDt[0]);
		})();

		return () => clearTimeout(loadId);
	}, [reload]);

	const utm = {
		utmCampaign: "Spring Sale 2019",
		utmContent: "Shoe and Shirts",
		utmMedium: "Ad",
		utmSource: "Facebook",
		utmTerm: "Spring",
	};

	const pageSettings = {
		backgroundColor: "ffffff",
		hideEventTypeDetails: false,
		hideLandingPageDetails: false,
		primaryColor: "00a2ff",
		textColor: "4d5055",
	};

	const prefill = {
		email: "",
		firstName: "",
		lastName: "",
		name: "",
		smsReminderNumber: "",
		guests: [""],
		// customAnswers: {
		// 	a1: "a1",
		// 	a2: "a2",
		// 	a3: "a3",
		// 	a4: "a4",
		// 	a5: "a5",
		// 	a6: "a6",
		// 	a7: "a7",
		// 	a8: "a8",
		// 	a9: "a9",
		// 	a10: "a10",
		// },
		date: new Date(Date.now() + 86400000),
	};

	useCalendlyEventListener({
		onEventScheduled: async (e) => {
			if (userData?.usersystemip) {
				return;
			}

			if (e.data.event === "calendly.event_scheduled") {
				try {
					const userSystemIp = await getSystemId();

					database.collection("sessionbooking").add({
						usersystemip: userSystemIp,
						count: 1,
					});
				} catch (error) {
					console.error("Failed to fetch IP address:", error);
				}
			}
		},
	});

	function handleClose() {
		setIsOpen(false);
		setShowPayment(false);
		setReload(true);
	}

	function handleOpen() {
		if (reload) {
			setReload(false);
		}
		if (userData?.usersystemip) {
			setShowPayment(!showPayment);
			setShowChat(false);
		} else {
			setIsOpen(true);
		}
	}

	return (
		<div>
			<button
				className={`fixed font-saira z-30 bottom-4 text-sm rounded-full px-4 py-2 ease-in duration-300 ${
					showChat ? "right-4" : "right-4 sm:right-24"
				} ${
					isDay
						? `${
								userData?.usersystemip
									? "bg-green-700 hover:bg-green-800 text-white hover:text-neutral-300"
									: "bg-brandBlack hover:bg-neutral-700 text-white hover:text-neutral-200"
						  }`
						: `${
								userData?.usersystemip
									? "bg-green-700 hover:bg-green-800 text-white hover:text-neutral-300"
									: "bg-brandWhite hover:bg-neutral-300 text-black hover:text-neutral-800"
						  }`
				}`}
				onClick={handleOpen}>
				{userData?.usersystemip ? "Schedule a Meeting" : "Book a Free Call"}
			</button>
			<PopupModal
				url={
					userData?.usersystemip
						? "https://calendly.com/info-wiingr/scheduled-meeting"
						: "https://calendly.com/info-wiingr/30min"
				}
				pageSettings={pageSettings}
				utm={utm}
				prefill={prefill}
				onModalClose={handleClose}
				open={isOpen}
				rootElement={document.getElementById("root")}
			/>
		</div>
	);
};

export { Calendly };
export default Calendly;
